import { render, staticRenderFns } from "./Tample.vue?vue&type=template&id=60ea0c83&"
import script from "./Tample.vue?vue&type=script&lang=js&"
export * from "./Tample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports